import chroma from 'chroma-js';

export const getDarkTheme = colors => ({
  ...getBaseTheme(colors),
  'color-border-container': colors.color_gray_200,
  'color-border-grid': colors.color_gray_400,
  'color-border-grid-header': chroma(colors.color_gray_400).alpha(0.7),
  'color-border-gridColumn-header': colors.color_gray_200, //chroma(colors.color_action_500).alpha(0.8),

  'color-border-simpleGrid-cell': colors.color_gray_300,
  'color-border-simpleGrid-header': colors.color_gray_200,

  'boxShadow-container-alt': 'none',
  'boxShadow-container': 'none',
  'color-background-grid-preferences-columnCard': colors.color_gray_100,
  'color-background-grid-preferences-columnCard-hidden': colors.color_gray_300,
  'color-border-grid-preferences': colors.color_gray_400,
  'color-border-grid-preferences-columnCard': colors.color_gray_400,

  'color-background-sidebar': chroma(colors.color_gray_100).brighten(0.5),
  'border-sidebar': 'none',
  'color-text-sidebar': colors.color_text,

  'color-background-thumbnail': colors.color_gray_200,
  'color-text-thumbnail': colors.color_text,
  'color-border-thumbnail': colors.color_gray_300,

  'color-background-thumbnail-hover': chroma(colors.color_gray_200).alpha(0.3),
  'color-text-thumbnail-hover': colors.color_text,
  'color-border-thumbnail-hover': colors.color_gray_300,

  'color-border-wizard-icon-wait': colors.color_gray_400,
  'color-text-wizard-icon-wait': colors.color_gray_400,
  'color-text-wizard-content-wait': colors.color_gray_400,

  'boxShadow-dropdown': 'none',

  'color-background-switch': colors.color_gray_400,

  'color-text-tabs-disabled': colors.color_gray_400,
});

export const getLightTheme = colors => ({
  ...getBaseTheme(colors),
});

/**
 * @param {{font_weight: string, color_success_400: string, color_success_500: string, color_action_500: string, color_success_100: string, color_success_200: string, font_size: string, color_success_300: string, color_action_100: string, color_action_200: string, color_action_300: string, color_action_400: string, color_error_200: string, color_1: string, color_error_100: string, color_2: string, font_weight_bold: string, color_text: string, radius_large: string, font_size_large: string, font_size_small: string, color_text_inverted: string, radius_small: string, font_weight_light: string, color_highlight_100: string, color_gray_400: string, color_error_500: string, color_gray_500: string, color_error_400: string, color_gray_600: string, color_brand_secondary: string, color_error_300: string, color_gray_700: string, color_gray_100: string, color_gray_200: string, color_gray_300: string, color_warning_100: string, color_warning_200: string, color_transparent: string, color_warning_400: string, color_gray_800: string, color_brand_primary: string, color_warning_300: string, color_gray_900: string, color_warning_500: string}} colors
 * @returns {{"color-icon-alert-error": (string|string|*), "color-text-switch-disabled": (string|string|*), "color-text-switch": (string|string|*), "color-text-chip-success": (string|string|*), "color-background-select": (string|string|*), "color-background-select-disabled": (string|string|*), "color-border-container": (string|string|*), "color-border-radiobutton-active": string, "color-border-select-focus": (string|string|*), "color-text-button-secondary-disabled": (string|string|*), "color-text-footer": (string|string|*), "color-background-button-secondary-warning": (string|string|*), "color-icons": string, "color-background-page": (string|string|*), "color-background-dropdown": (string|string|*), "color-icon-checkbox": (string|string|*), "color-background-grid": (string|string|*), "color-text-dropdown-hover": (string|string|*), "color-border-checkbox-checked-disabled": (string|string|*), "color-background-button-primary-error": (string|string|*), "color-background-button-secondary": (string|string|*), "color-background-button-primary-hover": (string|string|*), "color-border-input-invalid": (string|string|*), "color-background-button-primary-success": (string|string|*), "color-text-dropdown": (string|string|*), "color-text-page": (string|string|*), "color-background-tooltip": string, "color-background-dropdown-hover": (string|string|*), "color-background-list-selected": string, "color-background-bar-error": (string|string|*), "color-text-container": (string|string|*), "color-border-radiobutton-disabled": string, "color-border-button-secondary": (string|string|*), "color-background-switch-disabled": (string|string|*), "color-link": string, "color-icon-checkbox-disabled": (string|string|*), "color-background-button-secondary-error": (string|string|*), "color-text-button-primary": (string|string|*), "color-background-datePickerDate": string, "color-background-list": string, "color-background-radioButton-active": string, "radius-alert": (string|string|*), "color-background-container-alt": (string|string|*), "color-icon-alert-success": (string|string|*), "color-background-switch": (string|string|*), "color-border-input": (string|string|*), "color-border-select-invalid": (string|string|*), "fontWeight-dropdown-selected": string, "color-background-button-primary-disabled": (string|string|*), "color-text-chip-warning": (string|string|*), "color-text-header": (string|string|*), "color-border-select-disabled": (string|string|*), "color-background-checkbox-checked": (string|string|*), "color-background-bar-success": (string|string|*), "boxShadow-dropdown": string, "color-background-button-secondary-success": (string|string|*), "color-background-chip-info": (string|string|*), "color-background-bar-warning": (string|string|*), "color-icon-alert-info": (string|string|*), "color-background-datePicker": string, "color-background-checkbox-checked-disabled": (string|string|*), "color-border-card-error": (string|string|*), "color-background-alert-success": (string|string|*), "boxShadow-container": string, "color-text-validation": (string|string|*), "color-text-input-disabled": (string|string|*), "color-border-container-alt": (string|string|*), "color-border-card-success": (string|string|*), "color-background-alert-warning": (string|string|*), "color-background-emptyState": string, "color-background-radioButton-disabled": string, "color-background-checkbox": (string|string|*), "color-background-grid-header": (string|string|*), "color-text-grid": (string|string|*), "color-border-modal": string, "radius-card": (string|string|*), "color-background-list-hover": string, "color-icon-alert-warning": (string|string|*), "color-text-grid-row-hover": (string|string|*), "color-border-button-secondary-disabled": (string|string|*), "color-border-checkbox-disabled": (string|string|*), "color-text-container-alt": (string|string|*), "color-background-button-primary-warning": (string|string|*), "color-background-button-primary": (string|string|*), "color-border-button-secondary-error": (string|string|*), "color-border-gridColumn-header": (string|string|*), "color-border-input-focus": (string|string|*), "color-border-input-disabled": (string|string|*), "color-text-dropdown-selected": (string|string|*), "color-border-button-secondary-success": (string|string|*), "color-text-page-inverted": (string|string|*), "color-background-chip-warning": (string|string|*), "color-background-gridColumn-header": (string|string|*), "color-background-alert-error": (string|string|*), "color-background-chip-success": (string|string|*), "boxShadow-container-alt": string, "color-text-switch-checked-disabled": (string|string|*), "color-background-grid-row-hover": (string|string|*), "color-background-checkbox-disabled": (string|string|*), "color-border-card": (string|string|*), "color-text-select-disabled": (string|string|*), "color-text-chip-info": (string|string|*), "color-text-gridColumn-header": (string|string|*), "color-background-alert-info": (string|string|*), "color-text-link": (string|string|*), "color-background-container": (string|string|*), "radius-container": (string|string|*), "color-background-button-secondary-hover": (string|string|*), "color-background-footer": (string|string|*), "color-background-switch-checked": (string|string|*), "color-background-dropdown-selected": *, "color-text-grid-header": (string|string|*), "color-border-card-warning": (string|string|*), "color-background-dialogBox": string, "color-background-modal": string, "color-background-chip-error": (string|string|*), "color-text-chip-error": (string|string|*), "color-background-card": (string|string|*), "color-border-select": (string|string|*), "color-text-button-secondary": (string|string|*), "color-border-button-secondary-warning": (string|string|*), "color-background-button-primary-disabled-hover": (string|string|*), "color-text-button-primary-disabled": (string|string|*), "color-border-button-secondary-hover": (string|string|*), "color-border-checkbox": (string|string|*), "color-background-input-disabled": (string|string|*), "color-border-checkbox-checked": (string|string|*), "color-background-header": (string|string|*), "color-border-dropdown": (string|string|*), "color-background-button-secondary-disabled": (string|string|*), "color-background-switch-checked-disabled": (string|string|*), "color-border-grid-header": (string|string|*), "color-background-input": (string|string|*)}}
 */
const getBaseTheme = colors => ({
  'color-text-link': colors.color_action_400,
  'color-background-page': colors.color_gray_100,
  'color-text-page': colors.color_text,
  'color-text-page-inverted': colors.color_text_inverted,

  'color-background-drawer': colors.color_gray_100,
  'color-text-drawer': colors.color_text,
  'color-icon-drawer-close': colors.color_text,
  'color-border-drawer-header': chroma(colors.color_text).alpha(0.35),

  'radius-alert': colors.radius_small,

  'color-background-alert-info': colors.color_action_100,
  'color-icon-alert-info': colors.color_action_500,

  'color-background-alert-success': colors.color_success_100,
  'color-icon-alert-success': colors.color_success_500,

  'color-background-alert-warning': colors.color_warning_100,
  'color-icon-alert-warning': colors.color_warning_500,

  'color-background-alert-error': colors.color_error_100,
  'color-icon-alert-error': colors.color_error_500,

  'color-background-bar-success': colors.color_success_400,
  'color-background-bar-warning': colors.color_warning_400,
  'color-background-bar-error': colors.color_error_400,

  'color-background-button-primary': colors.color_action_400,
  'color-text-button-primary': colors.color_2,
  'color-text-button-primary-disabled': colors.color_2,
  'color-background-button-primary-hover': colors.color_action_500,
  'color-background-button-primary-disabled': colors.color_gray_500,
  'color-background-button-primary-disabled-hover': colors.color_gray_500,

  'color-background-button-primary-dangerous': colors.color_error_500,
  'color-text-button-primary-dangerous': colors.color_2,
  'color-text-button-primary-dangerous-disabled': colors.color_2,
  'color-background-button-primary-dangerous-hover': colors.color_error_500,
  'color-background-button-primary-dangerous-disabled': colors.color_gray_500,
  'color-background-button-primary-dangerous-disabled-hover': colors.color_gray_500,

  'color-background-button-primary-success': colors.color_success_300,
  'color-background-button-primary-warning': colors.color_warning_300,
  'color-background-button-primary-error': colors.color_error_300,

  'color-background-button-secondary': colors.color_transparent,
  'color-background-button-secondary-disabled': colors.color_transparent,
  'color-text-button-secondary': colors.color_text,
  'color-text-button-secondary-disabled': colors.color_gray_500,
  'color-background-button-secondary-hover': colors.color_transparent,
  'color-background-button-secondary-success': colors.color_transparent,
  'color-background-button-secondary-warning': colors.color_transparent,
  'color-background-button-secondary-error': colors.color_transparent,

  'color-border-button-secondary': colors.color_action_400,
  'color-border-button-secondary-disabled': colors.color_gray_500,
  'color-border-button-secondary-hover': colors.color_action_500,
  'color-border-button-secondary-success': colors.color_success_400,
  'color-border-button-secondary-warning': colors.color_warning_400,
  'color-border-button-secondary-error': colors.color_error_400,

  'color-background-input': colors.color_transparent,
  'color-background-input-disabled': colors.color_gray_300,
  'color-border-input': colors.color_gray_900,
  'color-border-input-focus': colors.color_action_300,
  'color-border-input-invalid': colors.color_gray_900,
  'color-border-input-disabled': colors.color_gray_500,
  'color-text-input-disabled': colors.color_gray_600,

  'color-background-select': colors.color_transparent,
  'color-text-select': colors.color_text,
  'color-background-select-disabled': colors.color_gray_300,
  'color-border-select': colors.color_gray_900,
  'color-border-select-focus': colors.color_action_300,
  'color-border-select-invalid': colors.color_gray_900,
  'color-border-select-disabled': colors.color_gray_500,
  'color-text-select-disabled': colors.color_gray_600,

  'color-background-dropdown': colors.color_gray_100,
  'color-border-dropdown': colors.color_gray_300,
  'color-text-dropdown': colors.color_text,
  'color-background-dropdown-hover': colors.color_gray_200,
  'color-text-dropdown-hover': colors.color_text,
  'color-background-dropdown-selected': chroma(colors.color_highlight_100).alpha(0.35),
  'color-text-dropdown-selected': colors.color_text,
  'boxShadow-dropdown': '2px 2px 6px #ddd',
  'fontWeight-dropdown-selected': '700',

  'radius-container': colors.radius_large,
  'color-background-container': colors.color_gray_200,
  'color-text-container': colors.color_text,
  'color-border-container': colors.color_gray_400,
  'boxShadow-container': `2px 2px 6px ${colors.color_gray_400}`,
  'color-background-container-alt': colors.color_gray_300,
  'color-text-container-alt': colors.color_text,
  'color-border-container-alt': colors.color_gray_400,
  'boxShadow-container-alt': `2px 2px 6px ${colors.color_gray_400}`,

  'color-background-header': colors.color_1,
  'color-text-header': colors.color_2,

  'color-background-footer': colors.color_1,
  'color-text-footer': colors.color_2,

  'color-background-sidebar': colors.color_gray_200,
  'border-sidebar': `1px solid ${colors.color_gray_400}`,
  'color-text-sidebar': colors.color_text,

  'color-text-validation': colors.color_error_400,

  'color-background-checkbox': colors.color_transparent,
  'color-border-checkbox': colors.color_gray_900,
  'color-icon-checkbox': colors.color_gray_100,

  'color-background-checkbox-checked': colors.color_gray_900,
  'color-border-checkbox-checked': colors.color_gray_900,

  'color-background-checkbox-disabled': colors.color_gray_300,
  'color-border-checkbox-disabled': colors.color_gray_500,

  'color-background-checkbox-checked-disabled': colors.color_gray_300,
  'color-border-checkbox-checked-disabled': colors.color_gray_500,
  'color-icon-checkbox-disabled': colors.color_gray_600,

  'color-background-card': colors.color_gray_300,
  'radius-card': colors.radius_small,
  'color-border-card': colors.color_transparent,
  'color-border-card-success': colors.color_success_300,
  'color-border-card-warning': colors.color_warning_200,
  'color-border-card-error': colors.color_error_400,

  'color-background-switch': colors.color_gray_600,
  'color-text-switch': colors.color_2,
  'color-background-switch-disabled': colors.color_gray_400,

  'color-text-switch-disabled': colors.color_gray_900,
  'color-text-switch-checked': colors.color_2,
  'color-text-switch-checked-disabled': colors.color_gray_100,
  'color-background-switch-checked': colors.color_action_400,
  'color-background-switch-checked-disabled': colors.color_action_300,

  'color-background-chip-info': colors.color_action_300,
  'color-background-chip-success': colors.color_success_400,
  'color-background-chip-warning': colors.color_warning_200,
  'color-background-chip-error': colors.color_error_400,
  'color-background-chip-disabled': colors.color_gray_300,

  'color-text-chip-info': colors.color_text_inverted,
  'color-text-chip-success': colors.color_text_inverted,
  'color-text-chip-warning': colors.color_text_inverted,
  'color-text-chip-error': colors.color_text_inverted,
  'color-text-chip-disabled': colors.color_gray_600,

  'color-background-grid': colors.color_gray_100,
  'color-text-grid': colors.color_gray_900,
  'color-border-grid': colors.color_gray_500,
  'color-background-grid-row-hover': colors.color_gray_300,
  'color-text-grid-row-hover': colors.color_gray_900,

  'color-background-gridColumn-header': colors.color_action_500,
  'color-border-gridColumn-header': colors.color_gray_800,
  'color-text-gridColumn-header': colors.color_2,

  'color-background-grid-header': colors.color_gray_300,
  'color-text-grid-header': colors.color_gray_900,
  'color-border-grid-header': colors.color_gray_500,
  'font-size-grid-header': colors.font_size_small,
  'font-weight-grid-header': colors.font_weight_bold,

  'color-background-grid-preferences': colors.color_gray_200,
  'color-background-grid-preferences-columnCard': colors.color_gray_100,
  'color-background-grid-preferences-columnCard-hidden': colors.color_gray_400,
  'color-border-grid-preferences': colors.color_gray_500,
  'color-border-grid-preferences-columnCard': colors.color_gray_500,
  'color-text-grid-preferences-columnCard-dragHandle': colors.color_gray_600,

  'color-background-simpleGrid-highlightedRow': chroma(colors.color_action_100).alpha(0.5),
  'color-text-simpleGrid-highlightedRow': colors.color_text,

  'color-background-simpleGrid-cell': colors.color_gray_100,
  'color-background-simpleGrid-header': colors.color_gray_300,
  'color-border-simpleGrid-cell': colors.color_gray_500,
  'color-border-simpleGrid-header': colors.color_gray_500,

  'color-requiredIndicator': colors.color_error_400,
  'color-requiredIndicator-disabled': colors.color_gray_700,

  'color-background-thumbnail': colors.color_gray_200,
  'color-text-thumbnail': colors.color_text,
  'color-border-thumbnail': colors.color_gray_400,

  'color-background-thumbnail-hover': chroma(colors.color_action_100).alpha(0.2),
  'color-text-thumbnail-hover': colors.color_text,
  'color-border-thumbnail-hover': colors.color_action_100,

  'color-background-timeline-itemHead': colors.color_success_300,
  'color-foreground-timeline-itemHead': colors.color_success_300,
  'color-border-timeline-itemHead': colors.color_success_300,

  'color-text-wizard': colors.color_text,
  'color-background-wizard-icon-finish': colors.color_gray_100,
  'color-background-wizard-icon-wait': colors.color_transparent,
  'color-background-wizard-title-line': colors.color_gray_500,
  'color-border-wizard-icon-wait': colors.color_gray_500,
  'color-text-wizard-icon-wait': colors.color_gray_500,
  'color-text-wizard-content-wait': colors.color_gray_500,

  'color-text-tabs': colors.color_text,
  'color-text-tabs-active': colors.color_action_400,
  'color-text-tabs-disabled': colors.color_gray_500,
  'color-border-tabs': colors.color_gray_400,

  'color-background-datePicker': '',
  'color-background-datePickerDate': '',
  'color-background-dialogBox': '',
  'color-background-emptyState': '',
  'color-icons': '',
  'color-link': '',
  'color-background-list': '',
  'color-background-list-hover': '',
  'color-background-list-selected': '',
  'color-background-modal': '',
  'color-border-modal': '',
  'color-background-radioButton-active': '',
  'color-background-radioButton-disabled': '',
  'color-border-radiobutton-active': '',
  'color-border-radiobutton-disabled': '',
  'color-background-tooltip': '',
});
